import { render } from "./EmployeHeader.vue?vue&type=template&id=4d164846"
import script from "./EmployeHeader.vue?vue&type=script&lang=js"
export * from "./EmployeHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__